<label for="fc">Family code</label>
<div class="base-container fc-group">
    <input class="dp-input-control" type="text" id="fc" placeholder="Enter family code of the dikshyarthi"
    #fc="ngModel" name="fc" [(ngModel)]="familyCode" [class.dp-input-error]="fcLengthError" (keydown)="onKeydown($event)"
    (input)="fcLengthError=false;(!fc.value||(fc.value&&fc.value.length<12))?removeFamilyMembers():{}"
    (keyup)="($event.key==='Enter')?verifyFC():{}">
    @if ((fcLengthError)&&commonUtil.isMobileDevice()) {
        <small class="error-message">Family Code should be of 12 digits</small>
    }
    <button type="submit" class="dp-secondary-btn verify-fc" [disabled]="fc.invalid" [class.disabled]="!fc.value||(fc.value&&fc.value.length<12)" (click)="verifyFC()">Verify FC</button>
</div>
@if ((fcLengthError)&&!commonUtil.isMobileDevice()) {
    <small class="error-message">Family Code should be of 12 digits</small>
}

@if(showMembers){
    <label>Select relevant member</label>
    <div class="base-container members">
        @for (member of fcMembers; track member.mem_key) {
        <div class="member-radio-select"  [class.selected]="mem.checked" 
        (click)="(mem.checked)?memKeyNull():emitSelectedMemKey($index)">
            <div>
                <p class="name">{{member.mem_name+' '+member.mem_surname}}</p>
                <p class="date">{{member.mem_last_transaction_date | date:'dd MMM yyyy'}}</p>
            </div>
            <input #mem #memModel="ngModel" name="selectedMember" value="{{member.mem_key}}" type="radio" 
            [(ngModel)]="selectedMemKey" inert>
        </div>
        }
        @empty{
            @if(loading){
                @for (item of [1,1,1,1]; track $index) {
                    <div class="member-radio-select">
                        <p class="placeholder-glow d-flex flex-column ">
                            <span class="placeholder col-12 mb-2 rounded-1 loading" style="height: 20px"></span>
                            <span class="placeholder col-8 rounded-1 loading"></span>
                        </p>
                    </div>
                }
            }
            @else if(apiError){
                <span class="empty"><em>Something went wrong.</em></span>
            }
            @else {
                <p class="empty">No data found.</p>
            }
        }
    </div>
}


<span class="proceed">
    @if (!fc.value) {<button type="button" class="dp-destructive-btn" (click)="step.emit(1)">I don't have a family code</button>}
    @if(!showMembers||fcMembers.length===0){
        <button type="button" class="dp-primary-btn-disabled" disabled>Verify family code to enable</button>
    }
    @else{
        <button type="button" class="dp-primary-btn" (click)="step.emit(1)">Proceed to feedback</button>
        <!-- @if(selectedMemKey){
            <button type="button" class="dp-primary-btn" (click)="step.emit(1)">Proceed to update member</button>
        } -->
    }
</span>

